import { render, staticRenderFns } from "./notification-event.vue?vue&type=template&id=a1cdcf12&lang=pug&"
import script from "./notification-event.vue?vue&type=script&lang=js&"
export * from "./notification-event.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports